var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#comments_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.313 3.5h1.375v6.013H7.312zm.687 9a.96.96 0 0 1-.713-.291.99.99 0 0 1-.287-.722.96.96 0 0 1 .287-.721.96.96 0 0 1 .713-.291q.424 0 .713.29a.96.96 0 0 1 .287.722.99.99 0 0 1-.287.722A.96.96 0 0 1 8 12.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "comments_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgComments as ReactComponent };